import React from 'react'
import { WhyQberaa, WhyQberaaTitle, WhyQberaaContent, WhyQberaaRedBox, RedBox1, RedBox2, RedBoxContainer, RightRedBox1, RightRedBox2 } from './StyledComponents'
import { homeData, whyBestinMarket } from '../../../data/websiteData'
import { Grid, Col } from '../../../styles/GlobalTheme/GlobalStyledComponents';
import Differentiator from '../../../components/differentiator';
import Fade from 'react-reveal/Fade';

const WhyBestinMarket = () => {

    return (
        <WhyQberaa>
            <RedBoxContainer>
                <RightRedBox2></RightRedBox2>
                <RightRedBox1></RightRedBox1>
            </RedBoxContainer>
            <Grid>
                <Fade bottom cascade duration={1000}>
                    <WhyQberaaTitle>{whyBestinMarket.title}</WhyQberaaTitle>
                    <WhyQberaaContent>{whyBestinMarket.content}</WhyQberaaContent>
                    <WhyQberaaRedBox />
                </Fade>
                <Differentiator data={whyBestinMarket.differentiator}></Differentiator>
            </Grid>
        </WhyQberaa>
    )
}

export default WhyBestinMarket
